export default {
  title: 'Commandes',
};
